<script>
const layouts = {}
const requireContext = require.context('./layouts', false, /.*\.vue$/)
requireContext.keys().forEach(file => {
    const comp = requireContext(file).default
    if (comp && comp.name)
    {
        layouts[comp.name] = comp
    }
})

export default {
    name: 'Engage-Admin',

    metaInfo:
    {
        title: process.env.APP_NAME,
    },

    methods:
    {
        setLayout(layout)
        {
            this.layout = !layout || !layouts[layout] ? layouts[this.defaultLayout] : layouts[layout]
        },

        loadingStart()
        {
            document.getElementsByTagName('body')[0].classList.remove('loaded')
        },

        loadingEnd()
        {
            document.getElementsByTagName('body')[0].classList.add('loaded')
        }
    },

    data()
    {
        return {
            layout: null,
            defaultLayout: 'layout-main'
        }
    },

    mounted()
    {
        this.$store.dispatch('init')
    }

}
</script>

<template>
    <div id="app">
        <toast-container></toast-container>
        <transition name="fade">
            <component v-if="layout" :is="layout">
            </component>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/App.vue